/**
 * Склонение существительного по числу.
 *
 * Формы передаются как есть: [1 генерация, 2 генерации, 5 генераций].
 */
export function plural(count: number, forms: [string, string, string]): string {
  const absolute = Math.abs(count) % 100;
  const tail = absolute % 10;

  if (absolute > 10 && absolute < 20) {
    return forms[2];
  }

  if (tail > 1 && tail < 5) {
    return forms[1];
  }

  return tail === 1 ? forms[0] : forms[2];
}
